import api from '@shared/api';
import { CodePanelRevision } from './types';

interface CreateCodeAndTemplateBody {
  projectId: string;
  name: string;
  code: string;
}

interface TemplateAndRevision {
  templateId: string;
  revisionId: number;
}

interface RevisionResponse {
  revisionId: string;
}

interface CodePanelTemplateCode {
  code: string;
  pyCode: string;
  pyConfig: string;
  defaultConfig: string;
  description: string;
  type: string;
  internalResources: string[];
}

export type UpdateCodeVisualizationTemplate = {
  templateName: string;
  code: CodePanelTemplateCode;
  lastVersion?: number;
};

export const createCodePanelTemplateAndRevision = async (
  body: CreateCodeAndTemplateBody
): Promise<TemplateAndRevision> => {
  const response = await api.post<TemplateAndRevision>(
    'code-panels/templates',
    body
  );
  return response.data;
};

export const updateCodePanelRevision = async (
  templateId: string,
  newRevision: Partial<CodePanelRevision>
): Promise<RevisionResponse> => {
  const response = await api.post<RevisionResponse>(
    `code-panels/templates/${templateId}/revisions`,
    newRevision
  );
  return response.data;
};

export const getCodePanelRevisions = async (
  templateId: string,
  signal?: AbortSignal
): Promise<Array<CodePanelRevision>> => {
  const response = await api.get<{ revisions: Array<CodePanelRevision> }>(
    `code-panels/templates/${templateId}/revisions`,
    { signal }
  );
  return response.data.revisions;
};
